import React from 'react';
import clsx from 'clsx';
import { Profile } from '../../../../models/profile.model';
import styles from './profileHeader.module.scss';

interface ProfileHeaderProps {
  isEditing: boolean;
  onToggleEdit: () => void;
  profile?: Profile;
}

const ProfileHeader: React.FC<ProfileHeaderProps> = ({ isEditing, onToggleEdit, profile }) => {
  return (
    <header className={styles.header}>
      <div className={styles.identity}>
        <h1 className={styles.name}>
          {profile?.name}
          <button
            type="button"
            className={clsx(styles.edit, { [styles.editActive]: isEditing })}
            onClick={onToggleEdit}
            aria-label="Edit profile"
            aria-pressed={isEditing}
            disabled={!profile}
          >
            <span className={styles.editIcon} />
          </button>
        </h1>
        <span className={styles.role}>{profile?.role}</span>
      </div>

      <span className={styles.divider} />
    </header>
  );
};

export default ProfileHeader;
